export default "__VITE_ASSET__cKlsdGKp__"